<template>
    <div>
      <div class="intro-header">
          <div class="about-container">
              <h1>Parent Resources</h1>
          </div> 
      </div>

        <v-container class="resources">
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/leap-years-blog.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://abcquality.org/posts/2020/how-do-i-know-what-child-care-program-is-the-best-fit-for-my-child/" target="_blank">How do I know what child care program is the best fit for my child?</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        Whether you are searching for a large child care center, a faith-based center, or a smaller in-home program, the one common trait you should always seek in all options is the quality of the program.
                    </p>
                    <p>
                        <a href="https://abcquality.org/posts/2020/how-do-i-know-what-child-care-program-is-the-best-fit-for-my-child/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/leap-years-blog.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://abcquality.org/posts/2020/why-is-outdoor-play-and-learning-so-important-for-my-child/" target="_blank">Why is outdoor play and learning so important for my child?</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        For most parents and caregivers, it probably does not come as a surprise that children today spend less time outdoors than previous generations. In fact, according to several studies, children spend half as much time outdoors as children did 20 years ago. 
                    </p>
                    <p>
                        <a href="https://abcquality.org/posts/2020/why-is-outdoor-play-and-learning-so-important-for-my-child/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/leap-years-blog.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://abcquality.org/blog/" target="_blank">The Leap Years Blog</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        Ensuring kids thrive and helping parents survive.
                    </p>
                    <p>
                        <a href="https://abcquality.org/blog/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/abc-quality.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://abcquality.org/parent-resources/five-questions-for-child-care-interviews/" target="_blank">ABC Five Questions for Child Care Interviews</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        How a potential child care provider answers these five questions — and if they participate in the state’s ABC Quality program — tells you a lot about their level of care and commitment to quality.
                    </p>
                    <p>
                        <a href="https://abcquality.org/parent-resources/five-questions-for-child-care-interviews/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/CFEC.jpg" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3 id="family-guides-to-pk-and-k">
                            <a href="https://cfec.sc.gov/timely-topics" target="_blank">Family Guides to PK and K</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        There are six areas of growth and experience that research tells us are involved in helping a child progress and succeed. These guides offer a brief introduction to each area and provide samples of the experiences and skills children need in order to be prepared to move through preschool at three, four, and five years of age.
                    </p>
                    <p>
                        <a href="https://cfec.sc.gov/timely-topics" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/images/dept-ed-horizontal.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://scde.coursearc.com/content/supporting-early-literacy-home-parent-s-guide/lessons/introduction/" target="_blank">Supporting Early Literacy at Home: A Parent's Guide (Modules)</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        “Supporting Early Literacy at Home: A Parent's Guide” is a series of online, self-paced learning modules designed to provide information for parents and caregivers so that they can support their children’s early literacy development. 
                    </p>
                    <p>
                        <a href="https://scde.coursearc.com/content/supporting-early-literacy-home-parent-s-guide/lessons/introduction/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/SEL.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://sel.ed.sc.gov/parents/" target="_blank">Social and Emotional Learning Family Resources</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        An introduction video to inform parents on SE practices in schools. It provides them with insights on SEL in their own parenting practices in order to support their children’s social and emotional know-how. 
                    </p>
                    <p>
                        <a href="https://sel.ed.sc.gov/parents/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/readyrosielogo.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://healthyathome.readyrosie.com/en/activity-lists/" target="_blank">A Toolkit for Supporting Families Impacted by COVID-19</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        In order to serve educators and families during the COVID-19 crisis, ReadyRosie developed this free toolkit as a resource to support families with information and resources for supporting the children in their care.
                    </p>
                    <p>
                        <a href="https://healthyathome.readyrosie.com/en/activity-lists/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/scremote.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://scremotelearning.com/parents-students/" target="_blank">Supports for Remote Learning</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        This site is designed to support remote learning.
                    </p>
                    <p>
                        <a href="https://scremotelearning.com/parents-students/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/pbs.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://www.pbs.org/parents/" target="_blank">Tools for Families</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        Find tips and tools to help you play and learn at home!
                    </p>
                    <p>
                        <a href="https://www.pbs.org/parents/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/images/fs4k-new.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://scfirststeps.org/wp-content/uploads/2020/05/English-Poster_print.pdf" target="_blank">Profile of the Ready Kindergartner</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        South Carolina’s Profile of the Ready Kindergartner describes the physical, cognitive, social and emotional signs of school readiness. 
                    </p>
                    <p>
                        <a href="https://scfirststeps.org/wp-content/uploads/2020/05/English-Poster_print.pdf" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/resources/logos/abc-quality.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://abcquality.org/" target="_blank">ABC Quality</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        Connecting parents to high quality child care providers. 
                    </p>
                    <p>
                        <a href="https://abcquality.org/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/images/scccrr-new.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="https://www.sc-ccrr.org/" target="_blank">SC Child Care Resource &amp; Referral</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        Choosing child care is one of the most important decisions families make, but all too often they must rely on word-of-mouth. The South Carolina Child Care Resource &amp; Referral (SC-CCR&amp;R) help parents take the guesswork out of choosing care.
                    </p>
                    <p>
                        <a href="https://www.sc-ccrr.org/" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md2  class="resource-thumbnail">
                    <img src="/images/headstart.png" class="card-img-top" />
                </v-flex>
                <v-flex md10  class="resource-body">
                    <div class="resource-header">
                        <h3>
                            <a href="/resources/STEAMathome-ExploreOutside.pdf" target="_blank">Explore the Outdoors Together – A STEAM Activity Sheet</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        When children play outside in nature, it gives them the chance to explore their senses—by touching, seeing, smelling, hearing, and sometimes tasting things! They also learn to solve problems and observe the world around them. 
                    </p>
                    <p>
                        <a href="/resources/STEAMathome-ExploreOutside.pdf" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
            <v-layout align-center justify-center row wrap class="resource">
                <v-flex md8  class="resource-body">
                    <div class="resource-header">
                        <h3 id="germs">
                            <a href="/resources/Preschool_Lets-Play-and-Learn_Germs.pdf" target="_blank">Preschool Let’s Plan and Learn about Germs</a>
                        </h3>
                    </div>
                    <p class="resource-text">
                        Physical Development and Healthy Habits
                    </p>
                    <p>
                        <a href="/resources/Preschool_Lets-Play-and-Learn_Germs.pdf" target="_blank">Read More</a>
                    </p>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    mounted: function() {
        console.log(this.$router.currentRoute);
        var currentRoute = this.$router.currentRoute;
        if(currentRoute.hash){
            document.getElementById(currentRoute.hash.substr(1)).scrollIntoView();
        }
    }

};
</script>
<style scoped>
.resources {
    width: 75%;
    margin:0 auto;
}
.resource {
    margin-top:25px;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
}


.card-img-top {
    width: 75%;
    margin: 0 auto;
    display: block;
}
.resource-body{
    padding: 1.5rem;
}
.resource-header{
    border-bottom: 1px solid rgba(0,0,0,.125);
    font-size: 1.75rem;
}
.resource-text{
    padding-top: 20px;
}

@media screen and (max-width:960px) {
    .resource-thumbnail{
        width: 100%;
        border-right: 0px;
        border-bottom: 2px solid #dfdfdf;
    }
    .card-img-top{
        max-width: 200px;
        width: 100%;
        margin: 0 auto;
        display: block;
    }
    .resource-body {
        width:100%;
    }

}
    
</style>